
@if (duration()) {
  <span class="text__duration ci-caption-regular">
    {{ duration() | duration }} 
  </span>
}